var app_preloadPictures = null;
(function ($) {

    app_preloadPictures = function (pictureUrls, callback) {
        var i, j, loaded = 0;

        for (i = 0, j = pictureUrls.length; i < j; i++) {
            createImg(new Image(), pictureUrls[i]);
        }

        function createImg(img, src) {  
            img.onload = function () {
                if (++loaded === pictureUrls.length && callback) {
                    callback();
                }
            };

            img.onerror = function () {};
            img.onabort = function () {};
            img.src = src.url;

 
            if(src.main){
                $("#view" + src.view).append(img); 
            }else{
                img.class += "animation";
                img.setAttribute("data-index", src.index);
                img.setAttribute("data-view", src.view);
                src.elm = img;
                $("#animation").append(img);
            }

        }
    };

})(jQuery);
